var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSurveyReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.404,
    height: 31.51,
    viewBox: "0 0 25.404 31.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c,.d{fill:#fff;stroke:#11526a;stroke-linecap:round;stroke-linejoin:round}.a{stroke-width:.963px}.b{stroke-width:1.204px}.c{stroke-width:1.124px}.d{stroke-width:.562px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2037.272 -97.941)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2057.258,128.678H2039.65a1.9,1.9,0,0,1-1.9-1.9V103.165a1.9,1.9,0,0,1,1.9-1.9h13.172l6.331,6.973v18.541A1.9,1.9,0,0,1,2057.258,128.678Z",
    transform: "translate(0 0.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2059.9,125.951H2042.29a1.9,1.9,0,0,1-1.9-1.895V100.438a1.9,1.9,0,0,1,1.9-1.895h13.172l6.331,6.972v18.542A1.9,1.9,0,0,1,2059.9,125.951Z",
    transform: "translate(0.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2060.4,105.446h-6.812V98.554Z",
    transform: "translate(1.69 0.001)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6.631,
    transform: "translate(2044.319 108.458)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 4.838,
    transform: "translate(2053.014 108.458)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.533,
    transform: "translate(2044.319 112.651)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.776,
    transform: "translate(2044.319 116.844)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.776,
    transform: "translate(2044.319 121.703)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 13.066,
    transform: "translate(2045.028 112.947)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurveyReport);
export default __webpack_public_path__ + "static/media/icon-survey-report.e9ce16c8b90d47958ac08d2f336096a1.svg";
export { ForwardRef as ReactComponent };